export default __webpack_public_path__ + "static/media/the-villa1.c15875d0.webp";